import controller from './mail-viewer-recipients.controller';
import template from './mail-viewer-recipients.html';
import './mail-viewer-recipients.scss';

export default {
	template,
	bindings: {
		recipient: '<ngModel',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
